import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loader from "../../../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../../../common/breadcrumbs";
import { DetailsTestimonial } from "../../../../services/usermgmt.services";

const CentreTestimonialsView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  // const [query] = useSearchParams();
  const { center_id } = location.state || '';
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Center Management"),
      url: "/admin/center-management/center/list/1",
    },
    {
      title: t("Center Testimonials"),
      url: `/admin/center-management/center/testimonial/${center_id}/list/1`,
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];


  useEffect(() => {
    DetailsTestimonial(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {/* <div>
                <h6 className="main-content-label mb-3">{t("View Center")}</h6>
              </div> */}
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>Profile Image</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.profile_image
                                ? showdefault.profile_image
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Name</th>
                        <td className="text-capitalize text-break">
                          {showdefault && showdefault.name
                            ? showdefault.name
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Testimonial</th>
                        <td className="text-break">
                          {showdefault && showdefault.testimonial_text
                            ? capitalizeFirstLetter(showdefault.testimonial_text)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.list_heading.list_heading_created_date")}</th>
                        <td>
                          {showdefault && showdefault.createdAt
                            ? formateDate(showdefault.createdAt)
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CentreTestimonialsView;
